import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SentimentSatisfiedAltOutlinedIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import SelfImprovementOutlinedIcon from '@mui/icons-material/SelfImprovementOutlined';
import Diversity3OutlinedIcon from '@mui/icons-material/Diversity3Outlined';

const heroIcons = [
  <InfoOutlinedIcon sx={{ fontSize: 32, color: 'primary.main', mr: 1 }} />, // expectations
  <SentimentSatisfiedAltOutlinedIcon sx={{ fontSize: 32, color: 'custom.red', mr: 1 }} />, // fears
  <SelfImprovementOutlinedIcon sx={{ fontSize: 32, color: 'custom.blue', mr: 1 }} />, // roles
  <Diversity3OutlinedIcon sx={{ fontSize: 32, color: 'custom.yellow', mr: 1 }} />, // society's noise
];

const CYJHero = () => (
  <Box sx={{ bgcolor: 'custom.beige', py: { xs: 4, md: 7 }, px: { xs: 1, md: 0 }, mb: { xs: 3, md: 5 } }}>
    <Paper elevation={3} sx={{ p: { xs: 3, md: 5 }, borderRadius: 2, bgcolor: 'white', maxWidth: 900, mx: 'auto' }}>
      <Typography variant="h2" sx={{ color: 'primary.main', mb: 2, textAlign: 'center', fontFamily: 'Just Another Hand' }}>
        Craft Your Journey (CYJ) – Self-Discovery Package
      </Typography>
      <Typography variant="h5" sx={{ color: 'custom.blue', mb: 2, textAlign: 'center', fontWeight: 400 }}>
        A gentle, science-based journey back to you.
      </Typography>
      <Typography sx={{ mb: 2, fontSize: { xs: 17, md: 19 }, color: 'text.secondary', textAlign: 'center' }}>
        Have you ever looked at your life and thought…
      </Typography>
      <Box sx={{ maxWidth: 600, mx: 'auto', mb: 2 }}>
        <Typography sx={{ fontStyle: 'italic', color: 'text.primary', mb: 1, textAlign: 'center' }}>
          “I’m grateful… but why do I still feel heavy?”<br/>
          “I do so much… but I’m not sure who I am anymore.”<br/>
          “I want calm, clarity, and direction… but my mind feels crowded.”
        </Typography>
      </Box>
      <Typography sx={{ mb: 2, color: 'text.secondary', textAlign: 'center' }}>
        Sometimes it’s not that your life is wrong.<br/>
        It’s that you’ve been living it while carrying:
      </Typography>
      <Box sx={{ maxWidth: 500, mx: 'auto', mb: 2 }}>
        <Box component="ul" sx={{ color: '#555', fontSize: '1.05rem', m: 0, pl: 3, listStyle: 'none' }}>
          <Box component="li" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            {heroIcons[0]} expectations you didn’t choose
          </Box>
          <Box component="li" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            {heroIcons[1]} fears you never healed
          </Box>
          <Box component="li" sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            {heroIcons[2]} roles that slowly replaced your identity
          </Box>
          <Box component="li" sx={{ display: 'flex', alignItems: 'center' }}>
            {heroIcons[3]} and society’s noise that convinced you to “keep going” even when you feel lost inside
          </Box>
        </Box>
      </Box>
      <Typography sx={{ mb: 2, color: 'text.secondary', textAlign: 'center' }}>
        I created Craft Your Journey for that exact moment.<br/>
        Not to “fix” you — because you’re not broken.<br/>
        But to help you come back to yourself with clarity, compassion, and a guided plan.
      </Typography>
    </Paper>
  </Box>
);

export default CYJHero;
